const cartName = "khanakul-cart"
export const getCartItemLocal = () => JSON.parse(localStorage.getItem(cartName));
export const setCartItemLocal = (payload) => localStorage.setItem(cartName, JSON.stringify(payload));
export const clearCartLocal = () => localStorage.removeItem(cartName);

const address = "khanakul-address"
export const setAddressLocal = (payload) => localStorage.setItem(address, JSON.stringify(payload));
export const getAddressLocal = () => JSON.parse(localStorage.getItem(address));
export const clearAddressLocal = () => localStorage.removeItem(address);

const vendorData = "vendor-data"
export const getVendorDataLocal = () => JSON.parse(localStorage.getItem(vendorData));
export const setVendorDataLocal = (payload) => localStorage.setItem(vendorData, JSON.stringify(payload));
export const clearVendorDataLocal = () => localStorage.removeItem(vendorData);

const deliveryData = "del-khbzr-data"
export const getDeliveryDataLocal = () => JSON.parse(localStorage.getItem(deliveryData));
export const setDeliveryDataLocal = (payload) => localStorage.setItem(deliveryData, JSON.stringify(payload));
export const clearDeliveryDataLocal = () => localStorage.removeItem(deliveryData);

const orderContact = "khanakul-order-contact";
export const setOrderContact = (contact) => localStorage.setItem(orderContact, contact);
export const getOrderContact = () => localStorage.getItem(orderContact);

const khbsr = "khb_SECREAT";
export const setRole = (secreat) => localStorage.setItem(khbsr, secreat);
export const getRole = () => localStorage.getItem(khbsr);
export const clearRole = () => localStorage.removeItem(khbsr);
